export default function pressFilter() {
	const $body = $('body');
	
	if ($('.section-filter--press').length > 0) {
		$('.form-filter #field-type').on('change', filterPress);
		
		$('.form-search .search-form').on('submit', filterPress);

		var selectedType     = $('.section-filter').find('#field-type option:selected').val();

		if ( selectedType != '' ) {
			$('.form-search .search-form').submit();
		}
	}

	$('.form-search .btn-remove-text').on('click', function (e) {
		e.preventDefault();

		$('.form-search .search-form').submit();

	});

	function filterPress(e){
		e.preventDefault();

		var $ajaxContainer = $('.section-filter' );

		$.ajax({
			url: crb_site_ajax.ajaxurl,
			method: 'GET',
			data: {
				action:   'crb_filter_press',
				search:   $ajaxContainer.find('#s').val(),
				category: $ajaxContainer.find('#field-type option:selected').val(),
			},
			beforeSend() {
				$ajaxContainer.addClass('ajax-loading');
			},
			success: function( response ) {
				$ajaxContainer.removeClass('ajax-loading');
				$('.section-resources').remove();

				if ($(response).filter('.section-updates').length > 0) {
					$('.section-updates').remove();
				}

				pressFilterChangeUrl();

				$ajaxContainer.after(response);

				filterStatesList();

				btnRemoveText();
			},
			error() {
				$ajaxContainer.html('<h3>Error has occurred please try again!</h3>');
				$ajaxContainer.removeClass('ajax-loading');
			},
			always() {
				$ajaxContainer.removeClass('ajax-loading');
			}
		});
	}

	function pressFilterChangeUrl(){
		var modifiedUrl    = '';
		var newUrl         = '';
		var $ajaxContainer = $('.section-filter');
		var stateObject    = {
			resource_action: 'crb_filter_press',
			resource_search: $ajaxContainer.find('#s').val(),
			resource_type: $ajaxContainer.find('#field-type option:selected').val(),
		};

		if ( $ajaxContainer.find('#field-type option:selected').val() !== '' ) {
			modifiedUrl += '?category=' + $ajaxContainer.find('#field-type option:selected').val();
		}

		newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + modifiedUrl;

		stateObject.path = newUrl;
		window.history.pushState(stateObject, '', newUrl);
	}

	function filterStatesList() {
		var arrayOfFilters = [];
		var $container = $('.section-filter' );

		if ( $container.find('#s').val().length > 0 ) {
			arrayOfFilters.push({label: 'Search', value: $container.find('#s').val()});
		}

		if ( $container.find('#field-type option:selected').val().length > 0 ) {
			arrayOfFilters.push({label: 'Category', value: $container.find('#field-type option:selected').text()})
		}

		if (arrayOfFilters.length > 0) {
			$('.section-filter').next()
				.find('.shell').prepend('<ul class="filter-states"></ul>');

			$.each( arrayOfFilters, function( index, item ){
				$('.filter-states').append('<li><strong>' + item.label + ':</strong> ' + item.value + '</li>' );
			});
		}
	}

	function btnRemoveText() {
		$('.section-search .search-form input').on('keypress', function () {
			$body.addClass('typing');
		});

		$('.btn-remove-text').on('click', function (e) {
			e.preventDefault();
			$body.removeClass('typing');
			$('.section-search .search-form input').val('');
			$('.form-search .search-form').submit();
		});

		$('.section-search .search-form input').on('keyup', function (e) {
			if ($('.section-search .search-form input').val() === '') {
				$body.removeClass('typing');
			}
		});

		if ( $('.section-search .search-form').length > 0 ) {
			if ( $('.section-search .search-form input').val().length > 0 ) {
				$body.addClass('typing');
			}

			if ( $('.section-search .search-form input').val().length == 0 && $body.hasClass('typing') ) {
				$body.removeClass('typing');
			}
		}
		
		$('.form-search input').on('keypress', function () {
			$body.addClass('typing');
		});

		if ( $('.form-search').length > 0 ) {
			if ( $('.form-search input').val().length > 0 ) {
				$body.addClass('typing');
			}

			if ( $('.form-search input').val().length == 0 && $body.hasClass('typing') ) {
				$body.removeClass('typing');
			}
		}

		$('.btn-remove-text').on('click', function (e) {
			e.preventDefault();
			$body.removeClass('typing');
			$('.form-search input').val('');
		});

		$('.form-search input').on('keyup', function (e) {
			if ($('.form-search input').val() === '') {
				$body.removeClass('typing');
			}
		});
	}
}